import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';

export default function HomeCommonNavigation({ type }) {
    const laung = localStorage.getItem("laung");
    const [lan, setLan] = useState(laung ?? "en");
    const navigate = useNavigate();
    return (
        <div>
            <a onClick={() => navigate(`/${laung ?? "en"}/searchall?type=${type}`)}>{type == 1 ? "PBP" : type == 2 ? "WBO" : type == 3 ? "PTJ" : "Home"} &gt; </a>

        </div>
    )
}
